// extracted by mini-css-extract-plugin
export default {"color":"ColorInput_color__EJ39b"};